import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ValueComparison() {
  return <section className="w-full bg-[#0E2238] py-20 px-4 sm:px-6 lg:px-8" data-id="element-200">
      <div className="max-w-7xl mx-auto" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-202">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-203">
            Compara y{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-204">
              Decide Tú Mismo
            </span>
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto" data-id="element-205">
            ¿Qué prefieres? ¿Seguir gastando o invertir en conocimiento real?
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-206">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#132A44] border-2 border-red-500/30 rounded-xl p-8" data-id="element-207">
            <div className="text-center mb-6" data-id="element-208">
              <div className="inline-block p-3 bg-red-500/20 rounded-full mb-4" data-id="element-209">
                <XIcon className="w-8 h-8 text-red-400" data-id="element-210" />
              </div>
              <h3 className="text-2xl font-bold text-[#F2F4F8] mb-2" data-id="element-211">
                Sin Este Manual
              </h3>
              <p className="text-red-400 font-semibold" data-id="element-212">
                Sigues perdiendo dinero
              </p>
            </div>

            <ul className="space-y-4" data-id="element-213">
              <li className="flex items-start gap-3" data-id="element-214">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-215" />
                <span className="text-[#F2F4F8]/80" data-id="element-216">
                  Gastas de más en creatinas "premium" por el mismo producto /
                  calidad
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-217">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-218" />
                <span className="text-[#F2F4F8]/80" data-id="element-219">
                  Compras "creatina" que no contiene creatina por comprar lo más
                  barato
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-220">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-221" />
                <span className="text-[#F2F4F8]/80" data-id="element-222">
                  Caes en marketing engañoso una y otra vez
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-223">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-224" />
                <span className="text-[#F2F4F8]/80" data-id="element-225">
                  Desperdicias minimo $100.000 al año comprando mal
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-226">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-227" />
                <span className="text-[#F2F4F8]/80" data-id="element-228">
                  Nunca sabes si estás tomando la dosis correcta
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#132A44] border-2 border-[#2F6BFF] rounded-xl p-8 relative" data-id="element-229">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-230">
              <span className="bg-[#2F6BFF] text-white px-6 py-2 rounded-full text-sm font-bold" data-id="element-231">
                MEJOR OPCIÓN
              </span>
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-232">
              <div className="inline-block p-3 bg-[#2F6BFF]/20 rounded-full mb-4" data-id="element-233">
                <CheckIcon className="w-8 h-8 text-[#2F6BFF]" data-id="element-234" />
              </div>
              <h3 className="text-2xl font-bold text-[#F2F4F8] mb-2" data-id="element-235">
                Con Este Manual
              </h3>
              <p className="text-[#2F6BFF] font-semibold" data-id="element-236">
                Inviertes una vez, ahorras siempre
              </p>
            </div>

            <ul className="space-y-4" data-id="element-237">
              <li className="flex items-start gap-3" data-id="element-238">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-239" />
                <span className="text-[#F2F4F8]/80" data-id="element-240">
                  Sabes exactamente qué creatina comprar
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-241">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-242" />
                <span className="text-[#F2F4F8]/80" data-id="element-243">
                  Identificas productos de calidad vs. estafa
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-244">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-245" />
                <span className="text-[#F2F4F8]/80" data-id="element-246">
                  Sabes todo lo necesario sobre creatina con base científica
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-247">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-248" />
                <span className="text-[#F2F4F8]/80" data-id="element-249">
                  Ahorras miles al año en suplementos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-250">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-251" />
                <span className="text-[#F2F4F8]/80" data-id="element-252">
                  Obtienes los resultados esperados.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        
      </div>
    </section>;
}